import Control from '@/components/control';
import { useContext } from '@/components/slider-type/context';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { selectAnswersDefaultByKey, selectControlStateByKey, SliderSlice } from '@/redux/slider';
import '@/components/slider-type/components/text/text-v1.css';
import '@/components/slider-type/components/text/text-v2.css';

export default function Text() {
  const { slide } = useContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const value = useAppSelector(selectAnswersDefaultByKey(slide.key));
  const state = useAppSelector(selectControlStateByKey(slide.key));
  const dispatch = useAppDispatch();

  const onChange = (key: string, value: string): void => {
    dispatch(SliderSlice.actions.setAnswersDefaultByKey({ key, value }));
  };

  return cssVersion === 1 ? (
    <div data-css-version={cssVersion} className='slider-type-text'>
      <input
        type='text'
        value={value}
        placeholder={slide.placeholder}
        className='slider-type-text__input'
        onChange={(e) => onChange(slide.key, e.target.value)}
        onBlur={() => dispatch(SliderSlice.actions.setValidationDirtyByKey(slide.key))}
      />
    </div>
  ) : (
    <div data-css-version={cssVersion} className='slider-type-text'>
      <Control.Text
        state={state}
        label={slide.placeholder || ''}
        id={slide.key}
        value={value}
        onChange={(value, id) => onChange(id, value)}
        onBlur={(id) => dispatch(SliderSlice.actions.setValidationDirtyByKey(id))}
      />
    </div>
  );
}
